(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('agendaLabelsMultiSelect', [AgendaLabelsMultiSelectDirectiveFn]);
    
    function AgendaLabelsMultiSelectDirectiveFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/appointmenttypes/templates/agenda-labels-multi-select.template.html',
            scope: {
                model: '=',
                labels: '='
            }
        };
        return directive;
    }

})();